<template>
    <img v-if="url" :src="url" id="image"/>
    <img v-else src="assets/layout/images/no-image.png"/>
</template>

<script>

    import Http from "@/commons/Http";

    export default {
        name: "ImageFromServer",
        props:{
            src: {type: String, default: null},
        },
        data(){
          return {
              server: process.env.VUE_APP_SERVER,
              url: null,
              loading: true,
          }
        },

        async mounted() {
          await this.getUrl();
          this.loading = false;
        },

        methods:{
          async getUrl(){
            if(!this.src){
              return;
            }

           Http.get(this.server+this.src, {responseType: 'blob'}).then(response => {
             this.url = URL.createObjectURL(response);
           });

          }

        }

    }
</script>

<style scoped>

</style>
